import React from "react";
import TrainingComponentEditor, { FormGroup } from "./TrainingComponentEditor";
import { action } from "mobx";
import { observer } from "mobx-react";

@observer
class Alert extends TrainingComponentEditor {
  initializeData() {
    return { text: "" };
  }

  @action.bound
  handleAlertChange(evt) {
    this.data.text = evt.target.value;
  }

  render() {
    return (
      <FormGroup name="text" label="Alert">
        {(formControl) => (
          <textarea
            {...formControl}
            value={this.data.text}
            onChange={this.handleAlertChange}
          />
        )}
      </FormGroup>
    );
  }
}

export default Alert;
